export default {
  previewHolder: {
    padding: '40px 0'
  }
}
